import { Component } from "react";
import moment from "moment";
import PropTypes from "prop-types";

class History extends Component {
    render() {
        const { log, i } = this.props;
        return (
            <div
                className="log-card"
                style={{
                    fontSize: "0.8em",
                }}
                key={`log-${i}`}
            >
                <div
                    className="log-card-flag"
                    style={{ backgroundColor: `#${log.ticket_color_hex}` }}
                ></div>
                {`${moment(log.created_at).format("HH:mm")}: ${log.session} - ${
                    log.quantity
                } - ${log.name}`}
            </div>
        );
    }
}

History.propTypes = {
    log: PropTypes.object.isRequired,
    i: PropTypes.number.isRequired,
};

export default History;
